(() => {
  function init(root) {
    if (!root || root.dataset.abMosaicReady === 'true') return;
    root.dataset.abMosaicReady = 'true';
    if (root.dataset.swapEnabled !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const tiles = Array.from(root.querySelectorAll('[data-ab-ss-tile]')).filter(tile => tile.querySelector('img') && !tile.querySelector('a'));
    const data = root.querySelector('[data-ab-ss-reserves]');
    let reserves = [];
    try { reserves = JSON.parse(data?.textContent || '[]'); } catch (_) { return; }
    reserves = reserves.filter(item => item && item.src && (item.shape === 'portrait' || item.shape === 'landscape'));
    if (!tiles.length || !reserves.length) return;
    const pools = {
      portrait: reserves.filter(item => item.shape === 'portrait'),
      landscape: reserves.filter(item => item.shape === 'landscape')
    };
    let lastSide = 'right', nextIndex = 0, timer = null, inView = false, swapping = false;
    const sideIndex = { left: 0, right: 0 };
    const interval = Math.max(7000, Number(root.dataset.interval) || 10000);
    function swap() {
      if (swapping) return;
      const available = tiles.filter(tile => (pools[tile.dataset.shape] || []).length);
      if (!available.length) return;
      const preference = lastSide === 'right' ? 'left' : 'right';
      const sideTiles = available.filter(tile => tile.closest('.ab-ss-mosaic__side--' + preference));
      const chosen = sideTiles.length
        ? sideTiles[sideIndex[preference]++ % sideTiles.length]
        : available[nextIndex % available.length];
      const pool = pools[chosen.dataset.shape];
      const candidate = pool.shift();
      if (!candidate) return;
      const image = chosen.querySelector('img');
      const previous = {
        src: chosen.dataset.currentSrc || image.currentSrc || image.src,
        alt: chosen.dataset.currentAlt || image.alt,
        focal: chosen.dataset.currentFocal || 'center center',
        shape: chosen.dataset.shape
      };
      nextIndex++;
      lastSide = preference;
      swapping = true;
      const preloader = new Image();
      const apply = () => {
        if (!root.isConnected) { swapping = false; return; }
        chosen.classList.add('is-changing');
        window.setTimeout(() => {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = candidate.src;
          image.alt = candidate.alt || '';
          chosen.style.setProperty('--ab-mosaic-focus', candidate.focal || 'center center');
          chosen.dataset.currentSrc = candidate.src;
          chosen.dataset.currentAlt = candidate.alt || '';
          chosen.dataset.currentFocal = candidate.focal || 'center center';
          pools[chosen.dataset.shape].push(previous);
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              chosen.classList.remove('is-changing');
              swapping = false;
            });
          });
        }, 675); // Wait for the 650ms CSS fade-out before replacing the photograph.
      };
      preloader.onload = apply;
      preloader.onerror = () => { pool.push(candidate); swapping = false; };
      preloader.src = candidate.src;
    }
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const start = () => { if (!timer && inView && !document.hidden) timer = setInterval(swap, interval); };
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; inView ? start() : stop(); }, { rootMargin: '100px 0px' });
      obs.observe(root);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) { stop(); obs.disconnect(); } });
    } else { inView = true; start(); }
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
  }
  function boot() { document.querySelectorAll('[data-ab-ss-mosaic]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();